uniform sampler2D uTexture;
uniform vec2 uMousePosition;    // Mouse position in 0-1 UV space
uniform vec2 uPrevPosition;     // Previous mouse position in 0-1 UV space
uniform float uEaseFactor;      // Easing factor for smooth movement
uniform float uMouseRadius;     // Single float for circular radius (0.0 to 1.0 range)
uniform float uAspectRatio;     // Aspect ratio (width/height) of the plane or viewport

varying vec2 vUv;

void main() {
    // Grid calculation (reduced grid size for better performance or visibility)
    vec2 gridUv = floor(vUv * vec2(80.0, 80.0)) / vec2(80.0, 80.0);
    vec2 centerOfPixel = gridUv + vec2(1.0/80.0, 1.0/80.0); 

    // Mouse direction
    vec2 mouseDirection = (uMousePosition - uPrevPosition) * 0.6;  // Amplify direction
    mouseDirection *= uEaseFactor;

    // Distance to mouse (using circular radius, corrected for aspect ratio)
    vec2 pixelToMouseDirection = centerOfPixel - uMousePosition;
    
    // Normalize the distance by aspect ratio to ensure a circular effect
    float aspectCorrectedX = pixelToMouseDirection.x * uAspectRatio;
    float pixelDistanceToMouse = length(vec2(aspectCorrectedX, pixelToMouseDirection.y)) / uMouseRadius;
    
    // Use a normalized threshold (e.g., 1.0 for full radius effect)
    float distanceThreshold = 5.0;  // Normalized threshold for the radius
    float strength = smoothstep(distanceThreshold, 0.0, pixelDistanceToMouse);

    // Apply distortion with increased strength
    vec2 uvOffset = strength * mouseDirection * 30.0;  // Maintain or adjust multiplier for strength
    vec2 uv = clamp(vUv - uvOffset, 0.0, 1.0);  // Clamp to prevent sampling outside texture

    vec4 textureColor = texture2D(uTexture, uv);
    
    gl_FragColor = textureColor;
}